import React from 'react';
import { Col, Form, Input, Row, Tag } from 'antd';
import { PriceMatrixEntry } from '../../../../../server/src/models';
import FormListRemoveButton from '../../FormListRemoveButton';

interface PriceMatrixEntryInputProps {
    isDetailMode: boolean;
    fieldName: number;
    prices: PriceMatrixEntry | undefined;
    remove: (index: number | number[]) => void;
}

const PriceMatrixEntryInput: React.FC<PriceMatrixEntryInputProps> = ({
    fieldName,
    isDetailMode,
    prices,
    remove,
}: PriceMatrixEntryInputProps) => {
    return (
        <Row gutter={24}>
            <Col span={5} offset={1}>
                <Form.Item
                    label={isDetailMode ? undefined : 'Max Weight (kg)'}
                    name={[fieldName, 'maxWeight']}
                    rules={[
                        {
                            required: !isDetailMode,
                            message: 'Weight threshold is required',
                        },
                    ]}
                >
                    {isDetailMode ? (
                        <span>{prices?.maxWeight}</span>
                    ) : (
                        <Input type="number" title="Weight threshold: maximum weight for this price" />
                    )}
                </Form.Item>
            </Col>
            <Col span={5} offset={isDetailMode ? 1 : 0}>
                <Form.Item label={isDetailMode ? undefined : 'Max Length (cm)'} name={[fieldName, 'maxLength']}>
                    {isDetailMode ? (
                        <span>{prices?.maxLength || 'NC'}</span>
                    ) : (
                        <Input type="number" title="Length threshold: maximum length for this price" />
                    )}
                </Form.Item>
            </Col>
            <Col span={5} offset={isDetailMode ? 1 : 0}>
                <Form.Item
                    label={isDetailMode ? undefined : 'Price'}
                    name={[fieldName, 'price']}
                    rules={[
                        {
                            required: !isDetailMode,
                            message: 'Price is required',
                        },
                    ]}
                >
                    {isDetailMode ? (
                        <span>{prices?.price}</span>
                    ) : (
                        <Input type="number" title="Price for the specified weight" />
                    )}
                </Form.Item>
            </Col>
            <Col span={5} offset={isDetailMode ? 1 : 0}>
                <Form.Item
                    label={isDetailMode ? undefined : 'Next day Price'}
                    name={[fieldName, 'nextDayPrice']}
                    rules={[
                        {
                            required: !isDetailMode,
                            message: 'Next day price is required',
                        },
                    ]}
                >
                    {isDetailMode ? (
                        <span>{prices?.nextDayPrice}</span>
                    ) : (
                        <Input type="number" title="Price for next day delivery on the specified max weight" />
                    )}
                </Form.Item>
            </Col>
            {!isDetailMode && (
                <Col span={1} offset={1}>
                    <FormListRemoveButton isDetailMode={isDetailMode} remove={remove} name={fieldName} />
                </Col>
            )}
        </Row>
    );
};

export default PriceMatrixEntryInput;
